/* JAP preview - light progressive enhancement only */
(function () {
  // Reveal on scroll
  const els = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && els.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  } else {
    els.forEach((el) => el.classList.add('in'));
  }

  // Promo countdown bar
  const timer = document.querySelector('.promobar__timer[data-deadline]');
  if (timer) {
    const cd = timer.querySelector('.cd');
    const end = new Date(timer.getAttribute('data-deadline')).getTime();
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) { const bar = timer.closest('.promobar'); if (bar) bar.style.display = 'none'; return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      cd.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'u ' + pad(m) + 'm ' + pad(s) + 's';
    };
    tick();
    setInterval(tick, 1000);
  }

  // Mobile nav drawer (off-canvas with backdrop + close button)
  const burger = document.querySelector('.burger');
  const nav = document.querySelector('.nav');
  if (burger && nav) {
    const backdrop = document.createElement('div');
    backdrop.className = 'nav-backdrop';
    document.body.appendChild(backdrop);

    const close = document.createElement('button');
    close.className = 'nav__close';
    close.setAttribute('aria-label', 'Sluit menu');
    close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>';
    nav.prepend(close);

    const setOpen = (open) => {
      nav.classList.toggle('nav--open', open);
      backdrop.classList.toggle('show', open);
      document.documentElement.classList.toggle('nav-open', open);
    };
    burger.addEventListener('click', () => setOpen(!nav.classList.contains('nav--open')));
    close.addEventListener('click', () => setOpen(false));
    backdrop.addEventListener('click', () => setOpen(false));
    nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  }

  // Belgische bezoekers herkennen (tijdzone, met taal als vangnet): zij krijgen de eerlijke
  // BE-belofte (1-2 werkdagen, soms 2-3) in plaats van "morgen in huis".
  const beVisitor = (() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz === 'Europe/Brussels') return true;
      if (tz === 'Europe/Amsterdam') return false;
    } catch (e) { /* geen tijdzone-info: val terug op browsertaal */ }
    return (navigator.language || '').toLowerCase().endsWith('-be');
  })();

  // Levertijd + live cutoff-countdown: op werkdagen voor 16:00 telt de deadline af (urgentie),
  // daarna/in het weekend tonen we de eerstvolgende leverdag.
  const dn = document.getElementById('deliveryNote');
  if (dn) {
    const span = dn.querySelector('span');
    if (span) {
      const days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
      const pad = (n) => String(n).padStart(2, '0');
      const nextDeliveryLabel = (from) => {
        const weekday = from.getDay() >= 1 && from.getDay() <= 5;
        const before = weekday && from.getHours() < 16;
        const d = new Date(from);
        d.setDate(d.getDate() + (before ? 1 : 2));
        while (d.getDay() === 0 || d.getDay() === 1) d.setDate(d.getDate() + 1); // geen zondag-/maandagbezorging (ma versturen, di leveren)
        const tomorrow = new Date(from); tomorrow.setDate(tomorrow.getDate() + 1);
        return d.toDateString() === tomorrow.toDateString() ? 'morgen' : days[d.getDay()];
      };
      const render = () => {
        const now = new Date();
        const weekday = now.getDay() >= 1 && now.getDay() <= 5;
        const cutoff = new Date(now); cutoff.setHours(16, 0, 0, 0);
        const diff = cutoff - now;
        if (weekday && diff > 0) {
          const h = Math.floor(diff / 3600000);
          const m = Math.floor((diff % 3600000) / 60000);
          const s = Math.floor((diff % 60000) / 1000);
          const t = (h > 0 ? h + 'u ' : '') + pad(m) + 'm ' + pad(s) + 's';
          span.innerHTML = beVisitor
            ? 'Nog <b>' + t + '</b> om vandaag te bestellen, <b>1-2 werkdagen</b> levertijd (soms 2-3)'
            : 'Nog <b>' + t + '</b> om vandaag te bestellen, <b>morgen in huis</b>';
          dn.classList.toggle('is-urgent', diff < 7200000); // < 2 uur = urgent
        } else {
          span.innerHTML = beVisitor
            ? 'Bestel nu, <b>binnen 1-2 werkdagen</b> in huis (soms 2-3)'
            : 'Bestel nu, <b>' + nextDeliveryLabel(now) + ' in huis</b>';
          dn.classList.remove('is-urgent');
        }
      };
      render();
      setInterval(render, 1000);
    }
  }

  // Product info tabs (PDP)
  document.querySelectorAll('.tabs').forEach((tabs) => {
    const btns = tabs.querySelectorAll('.tabs__btn');
    const panels = tabs.querySelectorAll('.tabs__panel');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-tab');
        btns.forEach((b) => b.classList.toggle('is-active', b === btn));
        panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-panel') === key));
      });
    });
  });

  // Bundle deal selection (PDP)
  document.querySelectorAll('.bundles').forEach((group) => {
    group.querySelectorAll('.bundle').forEach((b) => {
      b.addEventListener('click', () => {
        group.querySelectorAll('.bundle').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
      });
    });
  });

  // PDP sticky checkout bar: reveal once the main buy-box CTA is scrolled past
  const sticky = document.querySelector('.pdp-sticky');
  const mainCta = document.querySelector('.buybox__cta');
  if (sticky && mainCta && 'IntersectionObserver' in window) {
    const so = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    so.observe(mainCta);
  }

  // PDP gallery: desktop = klik wisselt de actieve slide; mobiel = horizontaal swipen
  const galMain = document.querySelector('.gallery__main');
  if (galMain) {
    const slides = galMain.querySelectorAll('.gallery__slide');
    const thumbs = document.querySelectorAll('.gallery__thumb');
    const dots = document.querySelectorAll('.gallery__dot');
    const isMobile = () => window.matchMedia('(max-width: 640px)').matches;
    const setActive = (i) => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => {
        setActive(i);
        if (isMobile() && slides[i]) {
          galMain.scrollTo({ left: i * galMain.clientWidth, behavior: 'smooth' });
        }
      });
    });
    // op mobiel volgen thumbs + dots de swipe
    let raf;
    galMain.addEventListener('scroll', () => {
      if (!isMobile()) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(galMain.scrollLeft / galMain.clientWidth);
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      });
    }, { passive: true });
  }

  // PDP: bundel kiezen werkt prijs + Klarna-bedrag live bij, en houdt de sticky-koopbalk
  // op DEZELFDE variant als de aangevinkte tier (anders voegt de sticky-knop Shopify's
  // default variant toe -> de eerste/mogelijk volle lading i.p.v. de gekozen lading)
  const priceEls = document.querySelectorAll('.js-main-price');
  const saveEls = document.querySelectorAll('.js-save');
  const klarnaEls = document.querySelectorAll('.js-klarna');
  const stickyIdInput = document.querySelector('.pdp-sticky input[name="id"]');
  const applyBundle = (input) => {
    const d = input.dataset;
    const priceHtml = d.price + (d.compare ? ' <small>' + d.compare + '</small>' : '');
    priceEls.forEach((el) => { el.innerHTML = priceHtml; });
    saveEls.forEach((el) => {
      if (d.save) { el.textContent = d.save; el.hidden = false; }
      else { el.hidden = true; }
    });
    if (d.klarna) klarnaEls.forEach((el) => { el.textContent = d.klarna; });
    if (stickyIdInput) stickyIdInput.value = input.value;
  };
  document.querySelectorAll('.bundle__input').forEach((input) => {
    input.addEventListener('change', () => applyBundle(input));
  });
  // Init: prijs + sticky-balk moeten de standaard-aangevinkte tier volgen, niet de Shopify-default
  // variant (die kan een volle/geblokkeerde lading zijn met een andere prijs).
  const checkedBundle = document.querySelector('.bundle__input:checked');
  if (checkedBundle) applyBundle(checkedBundle);

  // Topbar levertijd dynamisch houden (zelfde cutoff-logica als de PDP, zonder seconden).
  // Er zijn twee kopieën (origineel + marquee-kloon), dus alle matches bijwerken.
  const tbDeliver = document.querySelectorAll('.js-topbar-deliver');
  if (tbDeliver.length) {
    const tbDays = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
    const tbNextLabel = (from) => {
      const weekday = from.getDay() >= 1 && from.getDay() <= 5;
      const before = weekday && from.getHours() < 16;
      const d = new Date(from);
      d.setDate(d.getDate() + (before ? 1 : 2));
      while (d.getDay() === 0 || d.getDay() === 1) d.setDate(d.getDate() + 1); // geen zondag-/maandagbezorging
      const tomorrow = new Date(from); tomorrow.setDate(tomorrow.getDate() + 1);
      return d.toDateString() === tomorrow.toDateString() ? 'morgen' : tbDays[d.getDay()];
    };
    const tbRender = () => {
      const now = new Date();
      const weekday = now.getDay() >= 1 && now.getDay() <= 5;
      const html = beVisitor
        ? 'Voor 16:00 besteld, <b>binnen 1-2 werkdagen</b> in huis'
        : (weekday && now.getHours() < 16)
          ? 'Voor 16:00 besteld, <b>morgen in huis</b>'
          : 'Bestel nu, <b>' + tbNextLabel(now) + ' in huis</b>';
      tbDeliver.forEach((el) => { el.innerHTML = html; });
    };
    tbRender();
    setInterval(tbRender, 60000);
  }

  // Cookievoorkeuren opnieuw tonen (Shopify consent), met fallback naar privacybeleid
  const cookieBtn = document.getElementById('cookiePrefs');
  if (cookieBtn) {
    cookieBtn.addEventListener('click', () => {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.showPreferences === 'function') {
        Shopify.customerPrivacy.showPreferences();
      } else {
        window.location.href = '/policies/privacy-policy';
      }
    });
  }

  /* ----------------------------------------------------------------
     Productkaart: uitgeschreven "In winkelwagen" (AJAX) + "Mail mij
     zodra terug" (back-in-stock via de Cortex marketing engine).
     Endpoint + shopId zijn publiek (geen secrets); pas hier aan als
     de marketing engine van host wisselt.
  ---------------------------------------------------------------- */
  const BIS_ENDPOINT = 'https://thomasb.tailf40191.ts.net/api/tracking/back-in-stock';
  const SHOP_ID = '089a95f7-0cd6-472d-a32a-c377e83670c3';

  // Eén toast hergebruiken voor winkelwagen-feedback
  let toastEl = null;
  let toastTimer = null;
  const showToast = (text) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'jap-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span></span>';
    toastEl.querySelector('span').textContent = text;
    requestAnimationFrame(() => toastEl.classList.add('in'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('in'), 2600);
  };

  const refreshCartCount = () => {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const links = Array.from(document.querySelectorAll('a.icon-btn'));
        const cartLink = links.find((a) => (a.getAttribute('href') || '').indexOf('cart') !== -1);
        if (!cartLink) return;
        let count = cartLink.querySelector('.count');
        if (cart.item_count > 0) {
          if (!count) { count = document.createElement('span'); count.className = 'count'; cartLink.appendChild(count); }
          count.textContent = cart.item_count;
        } else if (count) {
          count.remove();
        }
      })
      .catch(() => {});
  };

  // Plaat-tegel in de platen-strip permanent als "in winkelwagen" markeren
  // (kaart-knoppen elders houden hun tijdelijke "Toegevoegd"-flits)
  const PLATE_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const markPlateAdded = (btn) => {
    const plate = btn.closest('.pdp-plate');
    if (!plate) return false;
    plate.classList.add('is-added');
    const badge = plate.querySelector('.pdp-plate__badge');
    if (badge) { badge.className = 'pdp-plate__badge pdp-plate__badge--in'; badge.innerHTML = PLATE_CHECK; }
    btn.classList.add('is-done');
    btn.disabled = true;
    btn.textContent = 'Toegevoegd';
    return true;
  };

  const handleCardAdd = (btn) => {
    const variantId = btn.getAttribute('data-variant-id');
    const url = btn.getAttribute('data-product-url');
    if (!variantId) { if (url) window.location.href = url; return; }
    const original = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(() => {
        refreshCartCount();
        showToast('Toegevoegd aan je winkelwagen');
        if (markPlateAdded(btn)) return;
        btn.classList.add('is-done');
        btn.textContent = 'Toegevoegd';
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = original; btn.disabled = false; }, 2200);
      })
      .catch(() => { btn.disabled = false; if (url) window.location.href = url; });
  };

  // Bij laden: platen die al in de winkelwagen zitten meteen zo tonen
  const plateBtns = document.querySelectorAll('.pdp-plate__add[data-variant-id]');
  if (plateBtns.length) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const inCart = new Set((cart.items || []).map((i) => i.variant_id));
        plateBtns.forEach((b) => {
          if (inCart.has(Number(b.getAttribute('data-variant-id')))) markPlateAdded(b);
        });
      })
      .catch(() => {});
  }

  // Cross-sell (vaak samen gekocht + inline accessoires): selectie -> live totaal + samen toevoegen (AJAX)
  document.querySelectorAll('.fbt').forEach((fbt) => {
    const boxes = Array.from(fbt.querySelectorAll('input[type="checkbox"][data-id]'));
    const totalEl = fbt.querySelector('.js-fbt-total');
    const addBtn = fbt.querySelector('.js-fbt-add');
    const labelEl = fbt.querySelector('.js-fbt-btn-label');
    const fixedLabel = fbt.classList.contains('fbt--inline'); // inline accessoire-blok houdt "Set in winkelwagen"
    if (!boxes.length || !addBtn) return;
    const fmtEuro = (cents) => {
      const v = (cents / 100).toFixed(2).split('.');
      return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    };
    const selected = () => boxes.filter((b) => b.checked);
    const update = () => {
      const sel = selected();
      const total = sel.reduce((s, b) => s + (parseInt(b.dataset.price, 10) || 0), 0);
      if (totalEl) totalEl.textContent = fmtEuro(total);
      addBtn.disabled = sel.length === 0;
      if (labelEl && !fixedLabel) labelEl.textContent = sel.length > 1 ? (sel.length + ' artikelen toevoegen') : 'In winkelwagen';
    };
    boxes.forEach((b) => b.addEventListener('change', update));
    addBtn.addEventListener('click', () => {
      const sel = selected();
      if (!sel.length) return;
      const items = sel.map((b) => ({ id: Number(b.dataset.id), quantity: 1 }));
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(() => {
          refreshCartCount();
          showToast(items.length === 1 ? 'Toegevoegd aan je winkelwagen' : items.length + ' artikelen toegevoegd');
          addBtn.disabled = false;
        })
        .catch(() => { window.location.href = '/cart'; });
    });
    update();
  });

  // Back-in-stock modal (native <dialog>, lazy aangemaakt)
  let bisModal = null;
  let bisProduct = null;
  const buildBisModal = () => {
    const dlg = document.createElement('dialog');
    dlg.className = 'bis-modal';
    dlg.setAttribute('aria-label', 'Bericht bij terug op voorraad');
    dlg.innerHTML =
      '<div class="bis-modal__inner">' +
      '<button type="button" class="bis-modal__close" aria-label="Sluiten"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>' +
      '<h3 class="bis-modal__title">Laat je e-mail achter</h3>' +
      '<p class="bis-modal__sub">We sturen je een bericht zodra <b class="bis-modal__name">dit product</b> weer op voorraad is. Geen spam, alleen deze ene melding.</p>' +
      '<form class="bis-modal__form" novalidate>' +
      '<input type="email" name="email" required placeholder="jouw@email.nl" class="bis-modal__input" autocomplete="email">' +
      '<button type="submit" class="bis-modal__submit">Houd mij op de hoogte</button>' +
      '</form>' +
      '<p class="bis-modal__msg" role="status" aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.querySelector('.bis-modal__close').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.querySelector('.bis-modal__form').addEventListener('submit', (e) => { e.preventDefault(); submitBis(dlg); });
    return dlg;
  };

  const openBis = (btn) => {
    bisProduct = {
      productId: btn.getAttribute('data-product-id'),
      productHandle: btn.getAttribute('data-product-handle'),
      productTitle: btn.getAttribute('data-product-title'),
      productUrl: btn.getAttribute('data-product-url'),
    };
    if (!bisModal) bisModal = buildBisModal();
    bisModal.querySelector('.bis-modal__name').textContent = bisProduct.productTitle || 'dit product';
    const form = bisModal.querySelector('.bis-modal__form');
    const msg = bisModal.querySelector('.bis-modal__msg');
    const submit = bisModal.querySelector('.bis-modal__submit');
    form.reset();
    form.style.display = '';
    msg.textContent = '';
    msg.className = 'bis-modal__msg';
    submit.disabled = false;
    submit.textContent = 'Houd mij op de hoogte';
    if (typeof bisModal.showModal === 'function') bisModal.showModal();
    else bisModal.setAttribute('open', '');
    const input = bisModal.querySelector('.bis-modal__input');
    setTimeout(() => input && input.focus(), 50);
  };

  const submitBis = (dlg) => {
    const form = dlg.querySelector('.bis-modal__form');
    const msg = dlg.querySelector('.bis-modal__msg');
    const submit = dlg.querySelector('.bis-modal__submit');
    const email = (form.email.value || '').trim();
    if (!email || email.indexOf('@') === -1) {
      msg.textContent = 'Vul een geldig e-mailadres in.';
      msg.className = 'bis-modal__msg is-err';
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Bezig...';
    msg.textContent = '';
    msg.className = 'bis-modal__msg';
    fetch(BIS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopId: SHOP_ID,
        email: email,
        productId: bisProduct ? bisProduct.productId : null,
        productHandle: bisProduct ? bisProduct.productHandle : null,
        productTitle: bisProduct ? bisProduct.productTitle : null,
        productUrl: bisProduct ? bisProduct.productUrl : null,
        source: 'product-card',
      }),
    })
      .then((r) => { if (!r.ok) throw new Error('bis failed'); return r.json().catch(() => ({})); })
      .then(() => {
        form.style.display = 'none';
        msg.textContent = 'Gelukt! We mailen je zodra het product er weer is.';
        msg.className = 'bis-modal__msg is-ok';
        setTimeout(() => dlg.close(), 2600);
      })
      .catch(() => {
        submit.disabled = false;
        submit.textContent = 'Houd mij op de hoogte';
        msg.textContent = 'Er ging iets mis. Probeer het later opnieuw.';
        msg.className = 'bis-modal__msg is-err';
      });
  };

  // Onderdelen-filter op de collectiepagina: de knoppen tonen alleen de kaarten
  // van het gekozen apparaat, zonder herladen. De knoppen zijn echte links naar
  // Shopify's tagfilter, dus zonder JS werkt het net zo goed (alleen trager).
  // Met [data-locked] laten we de links hun werk doen: dan staat niet alles op
  // één pagina en zou client-side filteren onvolledig zijn.
  const partFilter = document.querySelector('[data-partfilter]:not([data-locked])');
  if (partFilter) {
    const cards = Array.from(document.querySelectorAll('.grid--products .card[data-filter-groups]'));
    const chips = Array.from(partFilter.querySelectorAll('.partfilter__chip'));
    const emptyMsg = document.querySelector('[data-partfilter-empty]');
    const countLine = document.querySelector('[data-result-count]');
    const groupsOf = (card) => (card.dataset.filterGroups || '').split(/\s+/).filter(Boolean);

    const totals = { all: cards.length };
    cards.forEach((card) => groupsOf(card).forEach((g) => { totals[g] = (totals[g] || 0) + 1; }));
    chips.forEach((chip) => {
      const badge = chip.querySelector('.partfilter__count');
      if (!badge) return;
      badge.textContent = totals[chip.dataset.group] || 0;
      badge.hidden = false;
    });

    // Grootste groep vooraan: het apparaat met de meeste onderdelen wordt het
    // vaakst gezocht. Zonder JS blijft de alfabetische volgorde staan.
    const chipRow = partFilter.querySelector('.partfilter__chips');
    chips
      .filter((chip) => chip.dataset.group !== 'all')
      .sort((a, b) => (totals[b.dataset.group] || 0) - (totals[a.dataset.group] || 0))
      .forEach((chip) => chipRow.appendChild(chip));

    const applyGroup = (group) => {
      let shown = 0;
      cards.forEach((card) => {
        const match = group === 'all' || groupsOf(card).indexOf(group) !== -1;
        card.classList.toggle('is-filtered-out', !match);
        if (match) shown += 1;
      });
      chips.forEach((chip) => chip.classList.toggle('is-active', chip.dataset.group === group));
      if (emptyMsg) emptyMsg.hidden = shown > 0;
      if (countLine) {
        const chip = chips.find((c) => c.dataset.group === group);
        const label = group === 'all'
          ? countLine.dataset.scope
          : (chip ? chip.childNodes[0].textContent.trim() : countLine.dataset.scope);
        countLine.innerHTML = '<strong>' + shown + ' ' + (shown === 1 ? 'product' : 'producten') + '</strong>'
          + (label ? ' ' + (group === 'all' ? 'in ' : 'voor ') + label : '');
      }
    };

    partFilter.addEventListener('click', (e) => {
      const chip = e.target.closest('.partfilter__chip');
      if (!chip) return;
      e.preventDefault();
      const group = chip.dataset.group;
      applyGroup(group);
      const url = new URL(window.location.href);
      if (group === 'all') url.searchParams.delete('voor');
      else url.searchParams.set('voor', group);
      history.replaceState(null, '', url);
    });

    // Diepe link (?voor=...) meteen toepassen, bijvoorbeeld vanuit een mail of advertentie
    const wanted = new URL(window.location.href).searchParams.get('voor');
    if (wanted && chips.some((c) => c.dataset.group === wanted)) applyGroup(wanted);
  }

  // Eén gedelegeerde click-handler (werkt ook voor later ingeladen kaarten)
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest && e.target.closest('.js-card-add');
    if (addBtn) { e.preventDefault(); handleCardAdd(addBtn); return; }
    // Plaat-foto in de platen-strip: voegt toe via de bijbehorende prijs-knop
    // (niet zelf js-card-add: handleCardAdd vervangt textContent en zou de foto wissen)
    const proxy = e.target.closest && e.target.closest('.js-plate-proxy');
    if (proxy) {
      e.preventDefault();
      const btn = proxy.parentElement.querySelector('.js-card-add');
      if (btn && !btn.disabled) handleCardAdd(btn);
      return;
    }
    const bisBtn = e.target.closest && e.target.closest('.js-bis-open');
    if (bisBtn) { e.preventDefault(); openBis(bisBtn); }
  });
})();
